import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import { ILiquidation } from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';
import { Invoice } from './invoice.model';
import { Payment } from './payment.model';

export class Liquidation
  extends BaseModel<Liquidation, 'Liquidation'>
  implements ILiquidation
{
  amount!: number;
  invoiceId!: string;
  paymentId!: string;
  @Type(() => Date)
  creditBookingPeriod?: Date | null;
  reversedLiquidationId?: string | null;

  @Type(() => Invoice)
  invoice?: Invoice;

  @Type(() => Payment)
  payment?: Payment;
}
